export const operator = "https://t.me/poseidonchika_1"
export const operator2 = "https://t.me/poseidonchika_1"
export const chat = "https://goo.su/dFpux"
export const chanel = "https://goo.su/hsjtzb8"
export const bot1 = "https://t.me/jfhgsau2113_bot"
export const bot2 = "https://t.me/YOURBOT_DS_bot"
